
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { ClickEvent } from '@xt/client/types/home'

@Component({
  components: {}
})
export default class Recommend extends Vue {
  @Prop() dataSource: Array<{ cover: string; event?: ClickEvent; name: string }>

  @Emit('handle-click')
  handleClick(item) {
    return { item, type: 'buy' }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
